// src/pages/accounting/collateralReceived/components/CollateralReceivedFilter.jsx
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import CollateralDealerDropdown from '../../../../components/common/CollateralDealerDropdown';
import CollateralBankDropdown from '../../../../components/common/CollateralBankDropdown';
import CollateralTypeDropdown from '../../../../components/common/CollateralTypeDropdown';

const CollateralReceivedFilter = ({ th, canBrowseAllDealers, draftFilters, setDraftField, options, onApply, onReset, initiallyOpen = true }) => {
    const [open, setOpen] = useState(initiallyOpen);

    return (
        <div className="generic-table-filter mb-2">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button icon="pi pi-filter" label={th('filter.advancedFilter')} onClick={() => setOpen((p) => !p)} outlined={!open} type="button" />
                </div>
            </div>

            {open && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">{th('filter.advancedFilters')}</div>

                    <div className="grid">
                        {canBrowseAllDealers && (
                            <div className="col-12 md:col-6 lg:col-3">
                                <div className="field mb-2 p-1">
                                    <label className="block mb-1 text-sm">{th('collateralReceived.dealer')}</label>
                                    <CollateralDealerDropdown
                                        value={draftFilters.sapDealerId}
                                        onChange={(value) => setDraftField('sapDealerId', value)}
                                        placeholder={th('collateralReceived.selectDealer')}
                                        className="w-full"
                                    />
                                </div>
                            </div>
                        )}

                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('collateralReceived.numbers')}</label>
                                <InputText value={draftFilters.numbers ?? ''} onChange={(e) => setDraftField('numbers', e.target.value)} className="w-full" placeholder={th('collateralReceived.placeholders.numbers')} />
                            </div>
                        </div>

                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('collateralReceived.type')}</label>
                                <CollateralTypeDropdown value={draftFilters.type} onChange={(value) => setDraftField('type', value)} placeholder={th('common.all')} className="w-full" />
                            </div>
                        </div>

                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('collateralReceived.validity')}</label>
                                <InputText value={draftFilters.validity ?? ''} onChange={(e) => setDraftField('validity', e.target.value)} className="w-full" placeholder={th('collateralReceived.placeholders.validity')} />
                            </div>
                        </div>

                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('collateralReceived.currency')}</label>
                                <Dropdown
                                    value={draftFilters.currency}
                                    onChange={(e) => setDraftField('currency', e.value)}
                                    options={options.currencies}
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder={th('common.all')}
                                    className="w-full"
                                    showClear
                                    appendTo="self"
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('collateralReceived.bankName')}</label>
                                <CollateralBankDropdown value={draftFilters.bankName} onChange={(value) => setDraftField('bankName', value)} placeholder={th('common.all')} className="w-full" />
                            </div>
                        </div>

                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('collateralReceived.startDate')}</label>
                                <Calendar value={draftFilters.startDate} onChange={(e) => setDraftField('startDate', e.value)} dateFormat="dd/mm/yy" showIcon className="w-full" maxDate={draftFilters.endDate} placeholder={th('common.selectDate')} appendTo="self" />
                            </div>
                        </div>

                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('collateralReceived.endDate')}</label>
                                <Calendar value={draftFilters.endDate} onChange={(e) => setDraftField('endDate', e.value)} dateFormat="dd/mm/yy" showIcon className="w-full" minDate={draftFilters.startDate} placeholder={th('common.selectDate')} appendTo="self" />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3">
                        <Button label={th('filter.reset')} icon="pi pi-refresh" className="p-button-outlined mr-2" onClick={onReset} type="button" />
                        <Button label={th('filter.apply')} icon="pi pi-check" onClick={onApply} type="button" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default CollateralReceivedFilter;
